import { createFileRoute } from '@tanstack/react-router'
import { SavedPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/saved')({
  head: () => noIndexRouteHead('saved', 'en'),
  component: SavedPage,
})
